import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchItems,
  saveItem,
  deleteItem,
  updateItem,
} from 'src/store/actions/items';
import { fetchAllItemTypes } from 'src/store/actions/formOptions';
import { selectItems } from 'src/store/selectors/items';
import Heading from '../../components/Heading';
import Tabs from '../../components/Tabs';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { setSearch, clearSearch } from 'src/store/actions/search';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import { clearValidation } from 'src/store/actions/validation';
import { onClearResponseDone } from 'src/store/actions/suites';
import { stopLoaders } from 'src/store/actions/loader';
import {
  clearActiveTab,
  clearActiveSuiteTab,
  clearActiveCatalogTab,
  clearActiveContactTab,
} from 'src/store/actions/activeTab';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import ItemsTable from 'src/components/ItemsTable/ItemsTable';

const Catalog = () => {
  const dispatch = useDispatch();

  const items = useSelector(selectItems);
  const user = useSelector(selectAuthenticatedUser);
  const prloader = useSelector(selectPRLoader);

  /* PR loader (redux) starts false and only flips true after fetchItems
   * dispatches in the mount effect. Guard against the empty-state splash
   * flashing on first paint before redux flagged loading. */
  const [isInitialLoading, setIsInitialLoading] = useState<boolean>(true);

  useEffect(() => {
    if (prloader) {
      setIsInitialLoading(false);
    }
  }, [prloader]);

  const isLoadingItems: boolean = prloader || isInitialLoading;

  useEffect(() => {
    dispatch(clearActiveTab());
    dispatch(clearActiveSuiteTab());
    dispatch(clearActiveCatalogTab());
    dispatch(clearActiveContactTab());
  }, []);

  useEffect(() => {
    dispatch(stopLoaders());
    dispatch(fetchItems());
    dispatch(fetchAllItemTypes());
    dispatch(clearSearch());
    clearSuitesImportResponse();
  }, []);

  const clearSuitesImportResponse = () => {
    dispatch(clearValidation());
    dispatch(onClearResponseDone());
  };

  const onSaveItem = (item) => {
    let params = {};
    let properties = [];

    if (item.selectedProperties && item.selectedProperties.length > 0) {
      item.selectedProperties.map((sp) => {
        properties = [...properties, { id: sp.value }];
      });
    }

    if (item.id) {
      params = {
        id: item.id,
        name: item.name,
        MakeName: item.makeName,
        model: item.model,
        TypeId: item.typeId,
        warrantyYears: item.warrantyYears,
        UserId: user.id,
        properties: properties,
      };

      dispatch(updateItem(params));
    } else {
      params = {
        Name: item.name,
        MakeName: item.makeName,
        Model: item.model,
        TypeId: item.typeId,
        WarrantyYears: item.warrantyYears,
        UserId: user.id,
        properties: properties,
      };

      dispatch(saveItem(params));
    }
  };

  const onDeleteItem = (data) => {
    dispatch(deleteItem(data.id));
  };

  let brands = [];
  let itemTypes = [];

  if (items.length > 0) {
    items.map((item) => {
      if (brands.length === 0) {
        if (item.makeName) {
          brands.push(item.makeName);
        }
      } else {
        if (!brands.includes(item.makeName)) {
          if (item.makeName) {
            brands.push(item.makeName);
          }
        }
      }
      return false;
    });
  }

  if (items.length > 0) {
    items.map((item) => {
      if (itemTypes.length === 0) {
        itemTypes.push(item.typeName);
      } else {
        if (!itemTypes.includes(item.typeName)) {
          itemTypes.push(item.typeName);
        }
      }
      return false;
    });
  }

  return (
    <WithNavigation
      title="Catalog"
      top={
        <Heading
          headline="Catalog"
          loading={isLoadingItems}
          items={[
            {
              key: items.length > 1 ? 'Items' : 'Item',
              value: items.length,
            },
            {
              key: brands.length > 1 ? 'Brands' : 'Brand',
              value: brands.length,
            },
            {
              key: itemTypes.length > 1 ? 'Types' : 'Type',
              value: itemTypes.length,
            },
          ]}
        />
      }
      bottom={
        <Tabs
          items={[
            {
              label: 'Items',
              content: (
                <ItemsTable
                  items={items}
                  isLoadingItems={isLoadingItems}
                  onSaveItem={onSaveItem}
                  onDeleteItem={onDeleteItem}
                  onSearch={(e) =>
                    dispatch(setSearch({ items: e.target.value.trim() }))
                  }
                />
              ),
            },
          ]}
        />
      }
    />
  );
};

export default Catalog;
